import request from '@/utils/infrastructure/communication/request';

export async function updateFavorite({ id, isFavorite }) {
  const method = isFavorite ? 'delete' : 'post';
  return request[method](`/process/favorites/${id}`, {});
}

export async function queryProcessConfig(id) {
  return request(`/processEngine/start/${id}`);
}

export async function startProcess({ processId, formId, data = {} }) {
  return request.post(`/processEngine/start/${processId}/${formId}`, {
    headers: { 'Content-Type': 'application/json' },
    data,
  });
}
